module.exports = __webpack_public_path__ + "img/020.05943773.jpg";